export const createNoCacheHeaders = (scope: string): Record<string, string> => ({
  "Cache-Control": "no-cache",
  "If-None-Match": `"${scope}-${Date.now()}"`,
  Pragma: "no-cache",
});
